<template>
  <div class="w-full">
    <vx-card class="mb-5">
      <div class="lg:mx-4 md:m-0">
        <div class="mb-8">
          <h2 class="pt-2 title md:title">Bidding Details</h2>
        </div>

        <div class="lg:space-y-5 space-y-10">
          <div class="w-full md:flex md:space-x-12 space-y-10 lg:space-y-0">
            <div class="w-full md:w-1/2">
              <div class="mb-2">
                <label class="text-lg" for="">Industry</label>
              </div>
              <speakol-select
                id="bidding-industry-list"
                displayLabel="name"
                :reduce="category => category.id"
                :placeholder="'Choose industry'"
                :options="categories"
                ref="category_id"
                v-model="countryCategoryBid.category_id"
                validation="required"
                v-on:input="getBidConfigs"
              ></speakol-select>
            </div>

            <div class="w-full md:w-1/2">
              <div class="mb-2">
                <label class="text-lg" for="">Country</label>
              </div>
              <speakol-select
                id="bidding-country-list"
                displayLabel="name"
                :reduce="country => country.id"
                :placeholder="'Choose country'"
                :options="countries"
                ref="country_id"
                v-model="countryCategoryBid.country_id"
                validation="required"
                v-on:input="getBidConfigs"
              ></speakol-select>
            </div>
          </div>

          <div class="w-full md:flex md:space-x-12 space-y-10 lg:space-y-0">
            <div class="w-full md:w-1/2">
              <div class="mb-2">
                <label class="text-lg" for="">Min CPC</label>
              </div>
              <speakol-input
                id="bidding-min-cpc-input"
                :type="'number'"
                class="w-full"
                :placeholder="'Min CPC'"
                v-model="countryCategoryBid.cpc"
                ref="cpc"
                :step="'.01'"
                validation="required|decimal|min_value:0.000000000000000000001"
              ></speakol-input>
            </div>

            <div class="w-full md:w-1/2">
              <div class="mb-2">
                <label class="text-lg" for="">Min CPM</label>
              </div>
              <speakol-input
                id="bidding-min-cpm-input"
                :type="'number'"
                class="w-full"
                placeholder="Min CPM"
                v-model="countryCategoryBid.cpm"
                ref="cpm"
                :step="'.01'"
                validation="required|decimal|min_value:0.000000000000000000001"
              ></speakol-input>
            </div>
          </div>

          <div class="w-full md:flex md:space-x-12 space-y-10 lg:space-y-0">
            <div class="w-full md:w-1/2">
              <div class="mb-2">
                <label class="text-lg" for="">Min CPV</label>
              </div>
              <speakol-input
                id="bidding-min-cpv-input"
                :type="'number'"
                class="w-full"
                placeholder="Min CPV"
                v-model="countryCategoryBid.cpv"
                ref="cpv"
                :step="'.01'"
                validation="required|decimal|min_value:0.000000000000000000001"
              ></speakol-input>
            </div>

            <div class="w-full md:w-1/2">
              <div class="mb-2">
                <label class="text-lg" for="">Min CPA</label>
              </div>
              <speakol-input
                id="bidding-min-cpa-input"
                :type="'number'"
                class="w-full"
                placeholder="Min CPA"
                v-model="countryCategoryBid.cpa"
                ref="cpa"
                :step="'.01'"
                validation="required|decimal|min_value:0.000000000000000000001"
              ></speakol-input>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vs-button id="bidding-update-button" class="min-bid-update-button shadow-none btn-update md:btn-update" @click="update">Update</vs-button>

    <speakol-confirmation-popup
      v-on:hide-confirmation-popup="showConfirmationPopup = false"
      v-on:confirm="updateBidConfigurations($event)"
      :showConfirmationPopup="showConfirmationPopup"
      :title="'Confirmation'"
      :body="'Are you sure you want to Save changes ?'"
    />

    <speakol-response-popup
      v-on:hide-response-popup="responsePopupData.show = false"
      :responsePopupData="responsePopupData"
    />
  </div>
</template>

<script>

export default {
  data () {
    return {
      showConfirmationPopup: false,
      showResponsePopup: false,
      responsePopupData: {
        type: 'success',
        body: '',
        show: false
      },
      countries: [],
      categories: [],
      countryCategoryBid: {
        category_id: null,
        country_id: null,
        cpc: null,
        cpv: null,
        cpm: null,
        cpa: null
      }
    }
  },

  async created () {
    this.getCampaignCategories()

    this.getCountries()
  },
  methods: {
    async getCountries () {
      this.countries = await this.$store.getters['settings/countries']

      if (this.countries.length === 0) {
        await this.$store.dispatch('settings/getCountries')
        this.countries = this.$store.getters['settings/countries']
      }
    },

    async update () {
      await this.validate([
        'category_id',
        'country_id',
        'cpc',
        'cpv',
        'cpm',
        'cpa'
      ])

      // if (this.errors.items.length === 0)
      this.showConfirmationPopup = true
    },

    validate (keys) {
      keys.forEach(element => {
        this.$refs[element].validate()
      })
    },

    updateBidConfigurations () {
      window.axios
        .post('/bids/update', this.countryCategoryBid)
        .then(() => {
          this.showConfirmationPopup = false
          this.responsePopupData = {
            type: 'success',
            body: 'Min Bid config has been saved',
            show: true
          }
        })
        .catch(() => {
          this.showConfirmationPopup = false
          this.responsePopupData = {
            type: 'error',
            body: 'Error Data',
            show: true
          }
        })
    },

    async getCampaignCategories () {
      window.axios.get('/campaigns/categories').then(res => {
        this.categories = res.data.data
      })
    },

    getBidConfigs () {
      if (this.countryCategoryBid.country_id && this.countryCategoryBid.category_id) {
        window.axios.post('/bids', {
          country_id: this.countryCategoryBid.country_id,
          category_id: this.countryCategoryBid.category_id
        }).then(res => {
          if (res.data.data !== null) {
            this.countryCategoryBid = res.data.data
          } else {
            this.countryCategoryBid.cpc = null
            this.countryCategoryBid.cpv = null
            this.countryCategoryBid.cpm = null
            this.countryCategoryBid.cpa = null
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.title {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.1px;
  color: #2c2c2c;;
}

.btn-update {
  background: #0092d7;
  border-radius: 2.88px;
  height: 40px;
  border-radius: 2.88px;
  color: white;

  @apply w-full;
}

@media (min-width: 768px) {
  .md\:title {
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.1px;
    color: #2c2c2c;
  }

  .md\:btn-update {
    width: 130px;
  }
}

.min-bid-update-button {
  background-color: #0092d7 !important;
}
</style>
